/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AppState } from "ee/reducers";
import type { ModuleInstance } from "ee/constants/ModuleInstanceConstants";

export const getModuleInstanceById = (
  state: AppState,
  id: string,
): ModuleInstance | undefined => undefined;
